/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
import Vue from 'vue';
import store from '@/store';
import { whiteList } from '@/constant';

function routerBefore(to, from, next) {
  Vue.prototype.$tpLoadingTar.start();
  next();
}

function routerAfter(to, from, next) {
  if (!to.name || to.name === 'Error') {
    Vue.prototype.$tpLoadingTar.error();
  } else {
    Vue.prototype.$tpLoadingTar.finish(); // store.commit('globalStore/_isInMain', ['Home', 'Operation', 'Order', 'Mine', 'Event'].indexOf(to.name) !== -1)
    // 关闭加载进度条

    document.title = to.meta.name;
    Vue.prototype.$DingTalk.biz.navigation.setTitle({
      title: to.meta.name
    });
  }
}

export default {
  routerBefore: routerBefore,
  routerAfter: routerAfter
};